import { amplitude } from '@sennder/shell-utilities'

import { default as hj } from '@hotjar/browser'
declare type UserInfo = Record<
  string | number,
  string | number | Date | boolean
>

export const HotjarPluginName = 'hotjar'

// Amplitude's destination plugins report HTTP-style codes; 200 means success
const SUCCESS_CODE = 200
const FAILURE_CODE = 500

export const HotjarPlugin: amplitude.Plugin = {
  name: HotjarPluginName,
  type: 'destination',
  async execute(event: amplitude.Event): Promise<amplitude.Result> {
    if (!hj.isReady()) {
      return {
        code: FAILURE_CODE,
        event,
        message: 'Hotjar not initialized',
      }
    }

    // A throw here would reject the Amplitude timeline, so never let it escape
    try {
      if (event.event_type === '$identify') {
        const { user_id, device_id, user_properties } = event
        const hotjarId = user_id || device_id
        if (hotjarId) {
          // Amplitude identify payloads wrap attributes in operations like $set
          const attributes = (user_properties?.$set ?? {}) as UserInfo
          hj.identify(hotjarId, attributes)
        }
      } else {
        hj.event(event.event_type)
      }
    } catch (error) {
      return {
        code: FAILURE_CODE,
        event,
        message: `Hotjar call failed: ${(error as Error)?.message}`,
      }
    }

    return {
      code: SUCCESS_CODE,
      event,
      message: 'Event forwarded to Hotjar API',
    }
  },
}
